import { RestModel } from './core/RestModel'

export class ProductModel extends RestModel {
  constructor(data = {}) {
    super(data, {
      name: 'product',
      endpoint: '/products',
      schema: {
        id: Number,
        name: String,
        description: String,
        shortDescription: String,
        price: String,
        isNew: Boolean,
        isFeatured: Boolean,
        images: Array,
        specs: Array,
        documents: Array,
        variantGroups: Array,
        variants: Array,
        isActive: Boolean,
        hasWifiSupport: Boolean,
        categoryId: Number,
        brandId: Number,
        energyLabels: Array,
        createdAt: String,
        updatedAt: String,
      },
    })
  }
}

export default ProductModel
